module.exports = __webpack_public_path__ + "static/img/hongbar.e0540a53.png";